import React, { useState } from "react";
import AvailableEmployees from ".";
import PropTypes from "prop-types";

const Sidebar = ({ employeeToggle, entity, setEmployeeToggle }) => {
  const handleClick = () => {
    setEmployeeToggle({
      toggleState: !employeeToggle.toggleState,
      toggleClass: employeeToggle.toggleState
        ? "fa fa-chevron-right"
        : "fa fa-chevron-left",
    });
  };
  return (
    <>
      <span
        aria-hidden="true"
        className={employeeToggle.toggleClass}
        style={{
          fontSize: "24px",
          padding: "10px",
          position: "relative",
          backgroundColor: "#f1f1f2",
        }}
        onClick={() => handleClick()}
      ></span>

      {employeeToggle.toggleState ? <AvailableEmployees /> : <></>}
    </>
  );
};

Sidebar.prototypes = {
  setEmployeeToggle: PropTypes.func,
};

export default Sidebar;
